// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7fc2e684","750":"ff030fd4"}[chunkId] + ".chunk.js";
};